import type { ReactNode } from "react";
import { Box, Grid } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import BackLink from "@/components/BackLink";
import { ROUTES } from "@/helpers/routes/routePaths";

type JoinCampaignTopConfirmProps = {
  backLinkUrl?: string;
  children?: ReactNode;
};

function JoinCampaignTopConfirm({
  backLinkUrl = "",
  children,
}: JoinCampaignTopConfirmProps) {
  const [searchParams] = useSearchParams();
  const participantId = searchParams.get("participantId");
  const overviewParams = new URLSearchParams({
    tab: "direct-mail",
    participantId: participantId || "",
  });
  const navTo = participantId
    ? `${ROUTES.CAMPAIGN_OVERVIEW}?${overviewParams.toString()}`
    : backLinkUrl;
  return (
    <Box
      sx={{
        position: "fixed",
        top: "55px",
        zIndex: 999,
        maxWidth: "100%",
        width: {
          lg: "calc(100% - 240px)",
          xs: "100%",
        },
        background: "var(--neutral-200)",
        padding: ".7rem 1rem",
        marginX: "-15px",
      }}
    >
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 3 }}>
          <BackLink navTo={navTo} />
        </Grid>
        <Grid size={{ xs: 12, sm: "grow" }}>{children}</Grid>
      </Grid>
    </Box>
  );
}

export default JoinCampaignTopConfirm;
